import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layouts
import MainLayout from './components/layouts/MainLayout';
import AuthLayout from './components/layouts/AuthLayout';

// Pages
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import VehicleDetail from './pages/VehicleDetail';
import Geofences from './pages/Geofences';
import GeofenceDetail from './pages/GeofenceDetail';
import CreateGeofence from './pages/CreateGeofence';
import EditGeofence from './pages/EditGeofence';
import Alerts from './pages/Alerts';
import AlertDetail from './pages/AlertDetail';
import Reports from './pages/Reports';
import Login from './pages/Login';
import Register from './pages/Register';
import NotFound from './pages/NotFound';

// Auth components
import PrivateRoute from './components/auth/PrivateRoute';
import RoleRoute from './components/auth/RoleRoute';
import AuthGuardian from './components/auth/AuthGuardian';

function App() {
  return (
    <>
      <Routes>
        {/* Auth routes */}
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
        </Route>

        {/* Main app routes - protected */}
        <Route path="/" element={
          <PrivateRoute>
            <AuthGuardian>
              <MainLayout />
            </AuthGuardian>
          </PrivateRoute>
        }>
          <Route index element={<AuthGuardian><Dashboard /></AuthGuardian>} />
          <Route path="vehicles" element={<AuthGuardian><Vehicles /></AuthGuardian>} />
          <Route path="vehicles/:id" element={<AuthGuardian><VehicleDetail /></AuthGuardian>} />
          <Route path="geofences" element={<AuthGuardian><Geofences /></AuthGuardian>} />
          <Route path="geofences/new" element={<AuthGuardian><CreateGeofence /></AuthGuardian>} />
          <Route path="geofences/:id" element={<AuthGuardian><GeofenceDetail /></AuthGuardian>} />
          <Route path="geofences/:id/edit" element={<AuthGuardian><EditGeofence /></AuthGuardian>} />
          <Route path="alerts" element={<AuthGuardian><Alerts /></AuthGuardian>} />
          <Route path="alerts/:id" element={<AuthGuardian><AlertDetail /></AuthGuardian>} />
          
          {/* Admin and fleet manager only routes */}
          <Route path="reports" element={
            <AuthGuardian>
              <RoleRoute roles={['admin', 'fleet_manager']}>
                <Reports />
              </RoleRoute>
            </AuthGuardian>
          } />
        </Route>

        {/* 404 route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;